import { polyfill } from "smoothscroll-polyfill";

export default async (): Promise<void> => {
  polyfill(); // smooth scroll polyfill
};
